import logo from '../img/iol-logo.svg';
import React, { useEffect } from 'react';


function Header() {

	useEffect(() => {

	}, []);

	return (
		<>
			<nav className="navbar navbar-expand-lg">
				<div className="nav-wrapper row">
					<a className="navbar-brand col-6 col-xl-2" href="/">
						<img src={logo} alt="img" />
					</a>
					<button className="navbar-toggler-button" aria-label="Menu Toggler">
						<span className="iol-menu-icon navbar-toggler-icon-open"></span>
					</button>
					<div className="navbar-collapse-menu col-xl-8 closed">
						<ul className="navbar-nav">
							<li className="iol-lateral-button-wrapper">
								<a className="navbar-button col-lg-2" href="https://areaclienti.italiaonline.it" id="navbar-accedi">Accedi</a>
								<div className="iol-profile" id="navbar-iol-profile">
									<div className="iol-initials"></div>
									<div className="iol-name caption semibold"></div>
								</div>
							</li>
						</ul>
						<div className="navbar-utils-wrapper">
							<div className="navbar-utils dark-mode col-md-12">
								<a className="navbar-link iol_menu_selected" href="/" target="">Soluzioni per le aziende</a>
								<a className="navbar-link " href="/iol-advertising" target="">IOL Advertising</a>
								<a className="navbar-link " href="/corporate" target="">Corporate</a>
								<a className="navbar-link " href="/corporate/lavora-con-noi/" target="">Lavora con noi</a>
								<a className="navbar-link " href="/contatti/" target="">Contatti</a>
								<a className="navbar-link " href="https://areaclienti.italiaonline.it/" target="">Area clienti</a>
							</div>
						</div>
					</div>
				</div>
			</nav>
			<div className="searchbar-overlay" data-original-aria-hidden="" aria-hidden="true"></div>
		</>
	);
}

export default Header;